import React, { useState, useRef, useEffect } from "react";
import "../../styles/intake.css";

const ROLE_OPTIONS = ["Admin", "RN", "Esthetician", "MD"];

export default function RoleSelector({ selectedRoles, onChange }) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleRole = (role) => {
    if (selectedRoles.includes(role)) {
      onChange(selectedRoles.filter((r) => r !== role));
    } else {
      onChange([...selectedRoles, role]);
    }
  };

  return (
    <div className="role-selector" ref={dropdownRef}>
      <div className="dropdown-header" onClick={() => setOpen(!open)}>
        {selectedRoles.length > 0 ? selectedRoles.join(", ") : "Select roles..."}
        <span className="arrow">{open ? "▲" : "▼"}</span>
      </div>
      {open && (
        <div className="dropdown-list">
          {ROLE_OPTIONS.map((role) => (
            <label key={role} className="dropdown-item">
              <input
                type="checkbox"
                checked={selectedRoles.includes(role)}
                onChange={() => toggleRole(role)}
              />
              {role}
            </label>
          ))}
        </div>
      )}
    </div>
  );
}

